import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
  type: "participantName",
  value: "",
  participantName: null,
  participantAlias: null,
  onParameterPicked: false,
  searchWasMade: false,
  page: 1,
  size: 10,
};

const recipientsSearchSlice = createSlice({
  name: "recipientsSearch",
  initialState,
  reducers: {
    setSearchParameters: (state, action) => ({ ...state, ...action.payload }),
    clearSearchParameters: () => ({ ...initialState }),

    setType: (state, action) => {
      state.type = action.payload;
      state.value = "";
      state.participantName = null;
      state.participantAlias = null;
      state.onParameterPicked = true;
    },

    setValue: (state, action) => {
      state.value = action.payload ?? "";
    },

    commitCriteria: (state, action) => {
      const { participantName, participantAlias } = action.payload || {};
      state.participantName = participantName ?? null;
      state.participantAlias = participantAlias ?? null;
      state.searchWasMade = true;
      state.page = 1;
    },

    setPagination: (state, action) => {
      const { page, size } = action.payload || {};
      if (page !== undefined) state.page = page;
      if (size !== undefined) state.size = size;
    },
  },
});

export const {
  setSearchParameters,
  clearSearchParameters,
  setType,
  setValue,
  commitCriteria,
  setPagination,
} = recipientsSearchSlice.actions;

export const selectRecipientsSearch = (state) => state.recipientsSearch;

const isFilled = (v) =>
  Array.isArray(v)
    ? v.length > 0
    : typeof v === "string"
    ? v.trim() !== ""
    : v != null;

export const selectHasCriteria = createSelector(
  [selectRecipientsSearch],
  (s) =>
    isFilled(s.value) ||
    isFilled(s.participantName) ||
    isFilled(s.participantAlias)
);

export default recipientsSearchSlice.reducer;
